import TabsUI from "@/shared/components/atoms/TabsUI";
import { useCatchmentExportMutation } from "@/app/catchment/catchment.api";
import { CatchmentRequest } from "@/app/catchment/catchment.types";
import { useState } from "react";
import { MarketingTags } from "./components/MarketingTags";
import { UserTags } from "./components/UserTags";
import { Formik } from "formik";
import { useTranslation } from "react-i18next";
import { Permission } from "@/shared/hooks/usePermission";

export const initialValues: CatchmentRequest = {
  search: "",
  branch_filter: null,
  sex_filter: null,
  campaign_filter: null,
  stages_filter: null,
  stages_users_filter: null,
  tag_marketing_filter: null,
  catchment_page: "marketing",
};

export const TabsPage = () => {
  const [formValues, setFormValues] = useState(initialValues);

  const [t] = useTranslation();

  const tabs = [
    {
      id: "marketing",
      name: t("brand.views.marketing_tags"),
      permission: Permission.BRANCH_ACCESS_CREATE_EDIT_USER_AND_MARKETING_TAGS,
    },
    {
      id: "users",
      name: t("brand.views.user_tags_business_agreements"),
      permission: Permission.BRANCH_ACCESS_CREATE_EDIT_USER_AND_MARKETING_TAGS,
    },
  ];

  const [catchmentExport] = useCatchmentExportMutation();

  const handleExport = async () => {
    try {
      const response = await catchmentExport({
        ...formValues,
      }).unwrap();

      // Crear un blob con el tipo de contenido correcto
      const blob = new Blob([response], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      // Crear un enlace temporal para descargar el archivo
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "users.xlsx"); // Nombre del archivo
      document.body.appendChild(link);
      link.click();
      link.remove();

      // Liberar el objeto URL después de la descarga
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error exporting catchment:", error);
    }
  };

  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize
      validate={setFormValues}
      onSubmit={() => {}}
    >
      {({ values, setFieldValue }) => {
        return (
          <div className="flex-1">
            <div className="px-4">
              <TabsUI
                tabs={tabs}
                handleChange={(tab) => setFieldValue("catchment_page", tab)}
                current={values.catchment_page}
              />
            </div>
            <div className="mt-1">
              {values.catchment_page === "marketing" && (
                <MarketingTags exportData={handleExport} />
              )}
              {values.catchment_page === "users" && <UserTags />}
            </div>
          </div>
        );
      }}
    </Formik>
  );
};
